export default "__VITE_ASSET__BZL4Bw8w__"